import {
  CapiImage,
  VWIMAGE_SIZES,
  VWImageQuality,
} from '../modules/components';
import { isVilma, updateImageResolution } from '../modules/utils/image';
import { useEffect, useState } from 'react';

export interface ImageLoaderOptions {
  quality: VWImageQuality;
}

const useImageLoader = (images: CapiImage[], options: ImageLoaderOptions) => {
  const [validImages, setValidImages] = useState<CapiImage[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sourceImages, setSourceImages] = useState<CapiImage[]>([]);

  useEffect(() => {
    const uris = images.map(({ uri }) => uri);

    uris.forEach((uri: string, i: number) => {
      uris[i] = updateImageResolution(uri, VWIMAGE_SIZES[options.quality]);
    });

    setSourceImages(
      images.map((image: CapiImage, i: number) => {
        return {
          ...image,
          uri: uris[i],
        };
      })
    );
  }, []);

  useEffect(() => {
    const getImageResponses = async () => {
      setIsLoading(true);

      try {
        const responses = await Promise.all(
          sourceImages.map(({ uri }) => fetch(uri))
        );

        const validImages: CapiImage[] = [];

        responses.forEach(({ ok, redirected }, i: number) => {
          if ((redirected || isVilma(sourceImages[i].uri)) && ok) {
            validImages.push(sourceImages[i]);
          }
        });

        setValidImages(validImages);
        setIsLoading(false);
      } catch (_) {
        setIsLoading(false);
      }
    };

    if (sourceImages.length) getImageResponses();
  }, [sourceImages]);

  return { validImages, isLoading };
};

export default useImageLoader;
